// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  margin-left: 20px;
}

.list-view {
  display: flex;
  flex-direction: column;
  height: calc(100% - 20px);
  overflow: hidden;
}

.table-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin: 0 var(--content-margin);
  margin-bottom: 20px;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.table-container::-webkit-scrollbar {
  width: 8px;
}
.table-container::-webkit-scrollbar-track {
  background: transparent;
}
.table-container::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9);
}

table {
  width: 100%;
}

.compact {
  height: 38px !important;
}

.compact td,
.compact th {
  font-size: 9pt;
}

th {
  font-weight: bold;
}

tr.mat-mdc-row {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
tr.mat-mdc-row:hover {
  background-color: var(--preset-hover);
}

.card-container {
  margin: 10px 1rem 0 1rem;
  padding-bottom: 0.5rem;
}
.card-container .card {
  flex: 1;
  max-width: 360px;
}
.card-container .card .card-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-weight: bold;
  font-size: 14px;
}
.card-container .card .card-footer {
  text-align: center;
  margin: 0;
}

.hero-card {
  flex: 1;
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: center;
}
.hero-card .hero-left {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero-card .hero-left .hero-icon {
  font-size: 72px;
  width: 72px;
  height: 72px;
  opacity: 0.15;
}
.hero-card .hero-right {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hero-card .hero-right .hero-count {
  font-size: 3rem;
  font-weight: bold;
  line-height: 1;
}

.streams-card {
  text-align: center;
  font-size: 4rem;
  font-weight: bold;
  margin: 0;
}

.donut-legend-card {
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: center;
}
.donut-legend-card .left {
  width: 82px;
  height: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.donut-legend-card .left .stacked-spinner {
  position: absolute;
}
.donut-legend-card .right {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.labelled-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.clickable {
  cursor: pointer;
  border-radius: 50%;
  padding: 2px;
}
.clickable:hover {
  background-color: var(--preset-hover);
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  opacity: 0.6;
}
.empty-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.empty-state h3 {
  margin: 0;
}
.empty-state p {
  margin: 0;
  font-size: 0.9em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/streams-widget/streams-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,qBAAA;EACA,qDAAA;AACF;AACE;EACE,UAAA;AACJ;AACE;EACE,uBAAA;AACJ;AACE;EACE,oCAAA;EACA,kBAAA;AACJ;AACI;EACE,oCAAA;AACN;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAIA;;EAEE,cAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;AADF;AAGE;EACE,qCAAA;AADJ;;AAKA;EACE,wBAAA;EACA,sBAAA;AAFF;AAIE;EAeE,OAAA;EACA,gBAAA;AAhBJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;AACN;AAEI;EACE,kBAAA;EACA,SAAA;AAAN;;AAQA;EACE,OAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AALF;AAOE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALJ;AAOI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AALN;AASE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAPJ;AASI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAPN;;AAYA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;AATF;;AAYA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AATF;AAWE;EACE,WAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVJ;AAYI;EACE,kBAAA;AAVN;AAcE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAbF;;AAgBA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AAbF;AAeE;EACE,qCAAA;AAbJ;;AAiBA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAdF;AAgBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAdJ;AAiBE;EACE,SAAA;AAfJ;AAkBE;EACE,SAAA;EACA,gBAAA;AAhBJ","sourcesContent":[".container {\n  margin-left: 20px;\n}\n\n.list-view {\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 20px);\n  overflow: hidden;\n}\n\n.table-container {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  margin: 0 var(--content-margin);\n  margin-bottom: 20px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9);\n    }\n  }\n}\n\ntable {\n  width: 100%;\n}\n\n.compact {\n  height: 38px !important;\n}\n\n.compact td,\n.compact th {\n  font-size: 9pt;\n}\n\nth {\n  font-weight: bold;\n}\n\ntr.mat-mdc-row {\n  cursor: pointer;\n  user-select: none;\n\n  &:hover {\n    background-color: var(--preset-hover);\n  }\n}\n\n.card-container {\n  margin: 10px 1rem 0 1rem;\n  padding-bottom: 0.5rem;\n\n  .card {\n    .card-title {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 6px;\n      font-weight: bold;\n      font-size: 14px;\n    }\n\n    .card-footer {\n      text-align: center;\n      margin: 0;\n    }\n\n    flex: 1;\n    max-width: 360px;\n  }\n}\n\n.hero-card {\n  flex: 1;\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n  justify-content: center;\n\n  .hero-left {\n    width: 72px;\n    height: 72px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .hero-icon {\n      font-size: 72px;\n      width: 72px;\n      height: 72px;\n      opacity: 0.15;\n    }\n  }\n\n  .hero-right {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    .hero-count {\n      font-size: 3rem;\n      font-weight: bold;\n      line-height: 1;\n    }\n  }\n}\n\n.streams-card {\n  text-align: center;\n  font-size: 4rem;\n  font-weight: bold;\n  margin: 0;\n}\n\n.donut-legend-card {\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n  justify-content: center;\n\n  .left {\n    width: 82px;\n    height: 82px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .stacked-spinner {\n      position: absolute;\n    }\n  }\n\n  .right {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n\n.labelled-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.clickable {\n  cursor: pointer;\n  border-radius: 50%;\n  padding: 2px;\n\n  &:hover {\n    background-color: var(--preset-hover);\n  }\n}\n\n.empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  opacity: 0.6;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n  }\n\n  h3 {\n    margin: 0;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.9em;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
